import { Icon } from '@aqarmap/aqarmap-ui';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { getRandomNumber } from '~/lib/randomNumber';

const LocationsSkeleton = () => {
  return (
    <div className="overflow-y-auto pb-1.5x max-h-[300px]">
      {[...Array(5)].map((_, i) => (
        <div className="flex gap-x px-1.5x pt-2x pb-1.5x border-b border-gray w-full]">
          <Icon name="location" size="24px" className="text-gray__dark_1" />
          <div className="w-full flex-1">
            <Skeleton
              key={i}
              height={24}
              width={`${getRandomNumber(100, 300)}px`}
              borderRadius={12}
            />
            <Skeleton
              key={i}
              height={24}
              width={`${getRandomNumber(50, 90)}%`}
              borderRadius={12}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default LocationsSkeleton;
